import { Grid, Typography } from "@mui/material";
import type { HunterDetailLicenseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { LicenseCard } from "./LicenseCard";
import { PaperTitle } from "Components/Shared/PaperTitle";

const RESOURCES = Resources.Hunter.HuntersOverview.Detail;

type Props = {
  licenses: Array<HunterDetailLicenseDto>;
};

export const LicensesSection = ({ licenses }: Props) => {
  const { t } = useResource();

  return (
    <>
      <PaperTitle>{t(RESOURCES.Licenses)}</PaperTitle>

      {licenses.length === 0 && (
        <Typography variant="body1" color="text.secondary">
          {t(RESOURCES.NoLicensesFound)}
        </Typography>
      )}

      {licenses.length > 0 && (
        <Grid container spacing={2} maxWidth="850px">
          {licenses.map(({ publicID, code, licenseNo }) => (
            <LicenseCard key={publicID} code={code} licenseNo={licenseNo} />
          ))}
        </Grid>
      )}
    </>
  );
};
